// material-ui
import { PaletteMode } from "@mui/material";
import { createTheme } from "@mui/material/styles";

// assets

// ==============================|| DEFAULT THEME - PALETTE  ||============================== //

const Palette = (navType: PaletteMode | undefined) => {
  return createTheme({
    palette: {
      mode: navType,
      primary: {
        main: "#231B11",
        contrastText: "#C0B395"
      },
      secondary: {
        main: "#5F554A"
      },
      background: {
        default: "#514A3E",
        paper: "#453F35"
      },
      text: {
        primary: "#FFEFC8",
        secondary: "#C0B395"
      },
      error: {
        main: "#EE1A51"
      },
      warning: {
        main: "#EEAF1A"
      },
      divider: "#FFEFC8"
    }
  });
};

export default Palette;
